import React from "react";
import { FWSection, FWCard } from "../../../../design-system/fw";

function typeBadgeClass(typeKey) {
  if (typeKey === "child") return "hr-fp-pax__badge--child";
  if (typeKey === "infant") return "hr-fp-pax__badge--infant";
  return "hr-fp-pax__badge--adult";
}

export default function PassengerListCard({ passengers }) {
  return (
    <FWSection title="נוסעים">
      {passengers.length === 0 ? (
        <p className="fw-ui-results-hint" style={{ margin: 0 }}>
          אין רשימת נוסעים בנתונים שנשמרו
        </p>
      ) : (
        <FWCard>
          <ul className="hr-fp-pax__list">
            {passengers.map((p) => (
              <li key={p.key} className="hr-fp-pax__row">
                <span className="hr-order-secondary hr-fp-pax__name">{p.name}</span>
                <span className={`hr-fp-pax__badge ${typeBadgeClass(p.typeKey)}`}>{p.type}</span>
              </li>
            ))}
          </ul>
        </FWCard>
      )}
    </FWSection>
  );
}
